<template>
	<div>
		<div class="row content-header">
			<div class="content-header-left mb-2 col-md-9 col-12">
				<div class="row breadcrumbs-top">
					<div class="col-12">
						<h2 class="content-header-title float-left pr-1 mb-0">
							<feather-icon icon="ArrowLeftIcon" size="24" class="mr-2" @click="goBack" />Feed
						</h2>
						<div class="breadcrumb-wrapper">
							<ol class="breadcrumb">
								<li class="breadcrumb-item active">
									<span aria-current="location"> Add </span>
								</li>
							</ol>
						</div>
					</div>
				</div>
			</div>
		</div>
		<validation-observer ref="simpleRules">
			<b-form action="apps-purchase" method="post" @submit="addCompanyFeed">
				<b-card>
					<b-row>
						<b-col md="6">
							<b-form-group>
								<template v-slot:label> Purchase Date<span class="text-danger">*</span> </template>
								<validation-provider #default="{ errors }" name="purchase_date" rules="required">
									<b-form-datepicker
										name="purchase_date"
										v-model="FormData.purchase_date"
										menu-class="w-100"
										calendar-width="100%"
										class="mb-1"
										:max="maxDate"
									/>
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-form-group>
						</b-col>

						<b-col md="6">
							<b-form-group>
								<template v-slot:label> Production Type<span class="text-danger">*</span> </template>
								<div class="form-label-group">
									<validation-provider #default="{ errors }" name=" Production Type" rules="required">
										<v-select
											v-model="FormData.production_type_id"
											:options="productionTypes"
											label="name"
											clearable:false
											:reduce="(e) => e.id"
										/>
										<small class="text-danger">{{ errors[0] }}</small>
									</validation-provider>
								</div>
							</b-form-group>
						</b-col>
						<b-col md="6">
							<b-form-group>
								<template v-slot:label> Source<span class="text-danger">*</span> </template>
								<div class="form-label-group">
									<validation-provider #default="{ errors }" name=" Source" rules="required">
										<v-select
											v-model="FormData.source_id"
											:options="sourceList"
											label="name"
											clearable:false
											:reduce="(e) => e.id"
										/>
										<small class="text-danger">{{ errors[0] }}</small>
									</validation-provider>
								</div>
							</b-form-group>
						</b-col>

						<b-col md="6">
							<b-form-group>
								<template v-slot:label> Feed<span class="text-danger">*</span> </template>
								<div class="form-label-group">
									<validation-provider #default="{ errors }" name=" Feed Name" rules="required">
										<v-select
											v-model="FormData.feed_id"
											:options="feedList"
											label="name"
											clearable:false
											:reduce="(e) => e.id"
										/>
										<small class="text-danger">{{ errors[0] }}</small>
									</validation-provider>
								</div>
							</b-form-group>
						</b-col>
						<b-col md="6">
							<b-form-group>
								<template v-slot:label> Quantity <span class="text-danger">*</span> </template>
								<div class="form-label-group">
									<validation-provider
										#default="{ errors }"
										name="Quantity"
										:rules="{
											required: true,
											regex: RegExp(/^\d+(\.\d{1,4})?$/),
										}"
									>
										<b-form-input
											v-model="FormData.quantity"
											placeholder="Quantity"
											type="text"
											name="total_stock"
											maxlength="10"
										/>
										<small class="text-danger">{{ errors[0] }}</small>
									</validation-provider>
								</div>
							</b-form-group>
						</b-col>
						<b-col md="6">
							<b-form-group>
								<template v-slot:label> Rate (Rs.) Per Kg<span class="text-danger">*</span> </template>
								<div class="form-label-group">
									<validation-provider
										#default="{ errors }"
										name=" Rate (Rs.) Per Kg"
										:rules="{
											required: true,
											regex: RegExp(/^\d+(\.\d{0,2})?$/),
										}"
									>
										<b-form-input
											v-model="FormData.rate_per_kg"
											placeholder="Rate (Rs.) Per Kg"
											type="text"
											name="rate_per_kg"
											maxlength="10"
										/>
										<small class="text-danger">{{ errors[0] }}</small>
									</validation-provider>
								</div>
							</b-form-group>
						</b-col>
						<b-col md="6">
							<b-form-group>
								<template v-slot:label> Batch No. <span class="text-danger">*</span> </template>
								<div class="form-label-group">
									<validation-provider #default="{ errors }" name="Batch No. " rules="required">
										<b-form-input v-model="FormData.batch_no" placeholder="Batch No. " type="text" name="batch_no" />
										<small class="text-danger">{{ errors[0] }}</small>
									</validation-provider>
								</div>
							</b-form-group>
						</b-col>
						<!-- submit and reset -->
						<b-col cols="12">
							<b-button type="submit" variant="primary" value="Submit" class="mr-1 mb-3"> Submit </b-button>
						</b-col>
					</b-row>
				</b-card>
			</b-form>
		</validation-observer>
	</div>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";
import * as Vue from "vue";
import axios from "axios";
import { BASE_URL } from "@core/common/constants";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import axiosIns from "@/libs/axios";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, regex } from "@validations";
export default {
	components: {
		flatPickr,
		vSelect,
		Logo,
	},

	data() {
		return {
			required,
			regex,
			selected: null,
			FormData: {
				purchase_date: null,
				production_type: null,
				source_id: null,
				feed_type_id: null,
				quantity: null,
				rate_per_kg: null,
				batch_no: null,
			},
			feedList: [],
			productionTypes: [],
			sourceList: [],
			date: null,
			maxDate: new Date().toISOString().split("T")[0],
		};
	},
	created: function () {
		this.userData = JSON.parse(sessionStorage.getItem("userData") || localStorage.getItem("userData") || "null");
		this.getFeedTypes();
		this.getSourceTypes();
		this.getProductionTypes();
		// const current = new Date();
		// this.date = moment().format("dddd,MMMM DD,YYYY");
		// // this.date = `${current.getFullYear()}/${current.getMonth() + 1}/${current.getDate()}`;
		// debugger;
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		getSourceTypes() {
			axiosIns
				.get(`web/get-all-sources`)
				.then((response) => {
					this.sourceList = response.data.source_list;
				})
				.catch((error) => {
					this.$toast({
						component: ToastificationContent,
						position: "top-right",
						props: {
							icon: "CoffeeIcon",
							variant: "danger",
							text:
								error.response?.data?.message ||
								error.response?.data?.error ||
								(error.response?.data?.errors
									? Object.values(error.response.data.errors).flat().join(", ")
									: "Something went wrong. Please try again."),
						},
					});
				});
		},
		getProductionTypes() {
			axiosIns
				.get(`web/production-types`)
				.then((response) => {
					this.productionTypes = response.data.production_type.data;
				})
				.catch((error) => {
					this.$toast({
						component: ToastificationContent,
						position: "top-right",
						props: {
							icon: "CoffeeIcon",
							variant: "danger",
							text:
								error.response?.data?.message ||
								error.response?.data?.error ||
								(error.response?.data?.errors
									? Object.values(error.response.data.errors).flat().join(", ")
									: "Something went wrong. Please try again."),
						},
					});
				});
		},
		getFeedTypes() {
			axiosIns
				.get(`web/feeds`)
				.then((response) => {
					this.feedList = response.data.feed_list.data;
				})
				.catch((error) => {
					this.$toast({
						component: ToastificationContent,
						position: "top-right",
						props: {
							icon: "CoffeeIcon",
							variant: "danger",
							text:
								error.response?.data?.message ||
								error.response?.data?.error ||
								(error.response?.data?.errors
									? Object.values(error.response.data.errors).flat().join(", ")
									: "Something went wrong. Please try again."),
						},
					});
				});
		},

		async addCompanyFeed(e) {
			e.preventDefault();
			const companyId = this.userData && this.userData.company ? this.userData.company.id : null;
			const isValid = await this.$refs.simpleRules.validate();
			if (!isValid) return;
			debugger;
			// companyId from /me (you already have this.userData.company.id)
			if (!companyId) {
				this.$toast({
					component: ToastificationContent,
					position: "top-right",
					props: { icon: "CoffeeIcon", variant: "danger", text: "Company not found in user session." },
				});
				return;
			}

			// Build one payload (same for both)
			const data = new FormData();
			data.append("purchase_date", this.FormData.purchase_date);
			data.append("production_type_id", this.FormData.production_type_id);
			data.append("source_id", this.FormData.source_id);
			data.append("feed_id", this.FormData.feed_id);
			data.append("quantity", this.FormData.quantity);
			data.append("batch_no", this.FormData.batch_no);
			data.append("rate_per_kg", this.FormData.rate_per_kg); // only used by purchase-feed

			try {
				// 1) Always try old API first (outsourced purchase)
				await axiosIns.post(`web/purchase-feed`, data);

				this.$toast({
					component: ToastificationContent,
					position: "top-right",
					props: { icon: "CoffeeIcon", variant: "success", text: "Data Successfully Added" },
				});

				this.$router.push({ name: `apps-company-purchase` });
				return;
			} catch (error) {
				const status = error?.response?.status;
				const message = error?.response?.data?.message || "";
				const errors = error?.response?.data?.errors;

				// ✅ If backend blocks because formula exists -> auto call production API
				const isFormulaBlocked = status === 422 && (message || "").toLowerCase().includes("active formula");

				if (isFormulaBlocked) {
					try {
						// For production: you can send same FormData.
						// ProductionController ignores rate_per_kg, so it's safe to keep.
						await axiosIns.post(`web/company/${companyId}/feed-productions`, data);

						this.$toast({
							component: ToastificationContent,
							position: "top-right",
							props: { icon: "CoffeeIcon", variant: "success", text: "Feed produced successfully (RM deducted)" },
						});

						this.$router.push({ name: `apps-company-purchase` });
						return;
					} catch (err2) {
						const msg2 =
							err2?.response?.data?.message ||
							(err2?.response?.data?.errors
								? Object.values(err2.response.data.errors).flat().join(",")
								: "Feed production failed");

						this.$toast({
							component: ToastificationContent,
							position: "top-right",
							props: { icon: "CoffeeIcon", variant: "danger", text: msg2 },
						});
						return;
					}
				}

				// Normal validation errors from purchase-feed
				const msg = message || (errors ? Object.values(errors).flat().join(",") : "Request failed");

				this.$toast({
					component: ToastificationContent,
					position: "top-right",
					props: { icon: "CoffeeIcon", variant: "danger", text: msg },
				});
			}
		},
	},
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.invoice-add-wrapper {
	.add-new-client-header {
		padding: $options-padding-y $options-padding-x;
		color: $success;

		&:hover {
			background-color: rgba($success, 0.12);
		}
	}
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";
